import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/macro";
import { useMemo } from "react";

import { POOLS_TIME_RANGE_OPTIONS, PoolsTimeRange } from "domain/synthetics/markets/usePoolsTimeRange";
import { useLocalizedMap } from "lib/i18n";

import { Dropdown } from "components/Dropdown/Dropdown";
import Tabs from "components/Tabs/Tabs";

import { usePoolsIsMobilePage } from "./usePoolsIsMobilePage";

const LABEL_BY_POOLS_TIME_RANGE: Record<PoolsTimeRange, MessageDescriptor> = {
  "24h": msg`24H`,
  "7d": msg`7D`,
  "14d": msg`14D`,
  "30d": msg`30D`,
  total: msg`ALL`,
};

export default function PoolsTimeRangeFilter({
  setTimeRange,
  timeRange,
}: {
  setTimeRange: (timeRange: PoolsTimeRange) => void;
  timeRange: PoolsTimeRange;
}) {
  const labelsMap = useLocalizedMap(LABEL_BY_POOLS_TIME_RANGE);
  const isMobile = usePoolsIsMobilePage();
  const tabs = useMemo(
    () =>
      POOLS_TIME_RANGE_OPTIONS.map((item) => ({
        label: labelsMap[item],
        value: item,
      })),
    [labelsMap]
  );

  return (
    // <PoolsTabs<PoolsTimeRange>
    //   tabs={tabs}
    //   selected={timeRange}
    //   setSelected={setTimeRange}
    //   itemClassName="bg-slate-700 text-gray-lighter"
    // />
    <>
      {isMobile ? (
        <Dropdown
          options={tabs}
          onSelect={(option) => {
            const index = tabs.findIndex((o) => o.value === option.value);
            if (index !== -1) {
              setTimeRange(tabs[index].value);
            }
          }}
          selectedOption={tabs.find((tab) => tab.value === timeRange)}
          className="!min-w-40"
          classNameDropdownCurrent="!bg-gray-dark"
        />
      ) : (
        <Tabs
          options={tabs}
          selectedValue={timeRange}
          onChange={setTimeRange}
          qa="pools-time-range-filter"
          regularOptionClassname="!min-w-72"
          variant="ghost"
        />
      )}
    </>
  );
}
